import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ViewChild,
  inject,
  OnInit,
  ElementRef,
  HostListener,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AccountService } from '../account-service.service';
import { PersonService } from '../person.service';
import { UserAccount, DefaultUserAccount } from '../user-account';
import { PersonInterface, DefaultPersonTable } from '../person-interface';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTreeModule } from '@angular/material/tree';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { PersonalDataFormComponent } from '../personal-data-form/personal-data-form.component';
import { SocialZoneComponent } from '../social-zone/social-zone.component';
import { PersonalizeComponent } from '../personalize/personalize.component';
import { DataSharingService } from '../shared/data-sharing.service';
import { ClanMenuComponent } from '../clan-menu/clan-menu.component';
import {
  SubClan,
  subClans,
  TREE_DATA,
  TreeNode,
} from '../models/clan-interfaces'; // Import interfaces
import { ReactiveFormsModule } from '@angular/forms'; // Import this module
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ClanService } from '../clan.service';
import { environment } from '../../environments/environment';
import { retry } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserRatingComponent } from '../user-rating/user-rating.component';
import { CommonModule } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '../app.component';
import { provideHttpClient } from '@angular/common/http';
import { LanguageComponent } from '../language/language.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    // Other providers here
  ],
}).catch((err) => console.error(err));

@Component({
  selector: 'app-available-clans',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    // HttpClientModule,
    MatTabsModule,
    MatCheckboxModule,
    MatTreeModule,
    MatMenuModule,
    FormsModule,
    MatSelectModule,
    PersonalDataFormComponent,
    SocialZoneComponent,
    PersonalizeComponent,
    ClanMenuComponent,
    ReactiveFormsModule,
    // TODO: `HttpClientModule` should not be imported into a component directly.
    // Please refactor the code to add `provideHttpClient()` call to the provider list in the
    // application bootstrap logic and remove the `HttpClientModule` import from this component.
    //HttpClientModule,
    RouterModule,
    UserRatingComponent,
    CommonModule,
    LanguageComponent,
    TranslateModule,
  ],
  providers: [
    AccountService, // Add your service here
    PersonService,
    ClanService,
  ],
  template: `
    <mat-drawer-container class="example-container" [dir]="direction_" autosize>
      <!-- available-clans.component.html -->
      <mat-drawer #drawer mode="side" opened>
        <div class="example-action-buttons">
          <button mat-button (click)="accordion.openAll()">
            {{ 'available-clans.EXPAND_ALL' | translate }}
          </button>
          <button mat-button (click)="accordion.closeAll()">
            {{ 'available-clans.COLLAPSE_ALL' | translate }}
          </button>
          <button mat-button (click)="drawer.toggle()">
            {{ 'available-clans.HIDE' | translate }}
          </button>
        </div>
        <mat-accordion class="example-headers-align" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'available-clans.PERSONAL_DATA' | translate
              }}</mat-panel-title>
              <mat-panel-description>
                <mat-icon>account_circle</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <app-personal-data-form
              [userAccount]="userAccount_"
              (save)="onPersonalDataSaved()"
            ></app-personal-data-form>
          </mat-expansion-panel>
          <!-- #docregion Friends -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'available-clans.FRIENDS' | translate }}
              </mat-panel-title>
              <mat-panel-description>
                <mat-icon>contacts</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <app-social-zone></app-social-zone>
          </mat-expansion-panel>
          <!-- #enddocregion Friends -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'available-clans.PREFERENCES' | translate }}
              </mat-panel-title>
              <mat-panel-description>
                <mat-icon>settings</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <app-personalize></app-personalize>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> {{ 'LANGUAGE' | translate }} </mat-panel-title>
              <mat-panel-description>
                <mat-icon>language</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <app-language></app-language>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-drawer>

      <!--                                                                         CONTENT START -->
      <!-------------------------------------------------------------------------------------------------------------------->
      <mat-drawer-content>
        <div>
          <mat-toolbar>
            <button
              mat-icon-button
              class="example-icon"
              (click)="drawer.toggle()"
            >
              <mat-icon>menu</mat-icon>
            </button>
            <span>{{ 'available-clans.FAMILY' | translate }}</span>
            <button
              mat-fab
              color="primary"
              aria-label="add family button"
              (click)="clanMenu.openDialog('0ms', '0ms')"
            >
              <mat-icon>add</mat-icon>
            </button>
            <mat-form-field appearance="outline">
              <mat-label>{{
                'available-clans.FILTER_PLACEHOLDER' | translate
              }}</mat-label>
              <input
                matInput
                (keyup)="applyFilter($event)"
                placeholder="Ex. ium"
                #input
                class="rounded-input"
              />
            </mat-form-field>
            <span class="example-spacer"></span>
            <div class="rating-button-container" style="position: relative;">
              <!-- The button that toggles the rating component -->
              <button
                mat-icon-button
                class="example-icon favorite-icon"
                (click)="toggleRating()"
              >
                <mat-icon>favorite</mat-icon>
              </button>

              <!-- Dropdown for User Rating (positioned inside the button container) -->
              <div
                class="dropdown-container"
                #dropdownContainer
                *ngIf="showRating"
              >
                <app-user-rating (closeDropdown)="onDropdownClose()">
                </app-user-rating>
              </div>
            </div>

            <button mat-icon-button class="example-icon">
              <mat-icon>share</mat-icon>
            </button>
          </mat-toolbar>
        </div>
        <div>
          <!-- #docregion dynamic-height -->
          <mat-tab-group dynamicHeight (selectedTabChange)="selectTab($event)">
            <!-- #enddocregion dynamic-height -->
            <mat-tab label="{{ 'available-clans.THE_CLANS' | translate }}">
              <div class="example-small-box mat-elevation-z4">
                <table
                  mat-table
                  [dataSource]="clansDataSource"
                  class="mat-elevation-z8"
                >
                  <!-- Position Column -->
                  <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef>No.</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.position }}
                    </td>
                  </ng-container>
                  <!-- Checkbox Column -->
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="onRowSelectionChange(row)"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)"
                      >
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <!-- owner_name Column -->
                  <ng-container matColumnDef="owner_name">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'available-clans.TREE_OWNER' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.owner_name }}
                    </td>
                  </ng-container>
                  <!-- Name Column -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'available-clans.NAME' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.family_table_name }}
                    </td>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="start_of_family_name">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'available-clans.START_OF_FAMILY' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.family_table_start_of_family_name }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No data matching the filter "{{ input.value }}"
                    </td>
                  </tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="{{ 'available-clans.TREE_LABEL' | translate }}">
              <div class="example-large-box mat-elevation-z4">
                <mat-tree
                  [dir]="direction_"
                  [dataSource]="dataSourceTree"
                  [treeControl]="treeControl"
                  class="example-tree"
                >
                  <!-- This is the tree node template for leaf nodes -->
                  <!-- There is inline padding applied to this node using styles.
    This padding value depends on the mat-icon-button width. -->
                  <mat-tree-node
                    *matTreeNodeDef="let node"
                    matTreeNodeToggle
                    [dir]="direction_"
                  >
                    {{ node.name }}
                    <div (click)="handleButtonClick($event)">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="clanMenu.menu"
                        aria-label="Example icon-button with a menu"
                        (click)="onNodeClick(node)"
                        [disabled]="!islastSelectedClanFullAccessible_"
                      >
                        <mat-icon class="mat-icon-rtl-mirror">add_circle_outline</mat-icon>
                      </button>
                    </div>
                  </mat-tree-node>
                  <!-- This is the tree node template for expandable nodes -->
                  <mat-nested-tree-node
                    *matTreeNodeDef="let node; when: hasChild"
                  >
                    <div class="mat-tree-node">
                      <button
                        mat-icon-button
                        matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name"
                      >
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{
                            treeControl.isExpanded(node)
                              ? 'expand_more'
                              : direction_ === 'rtl'
                                ? 'chevron_left'
                                : 'chevron_right'
                          }}
                        </mat-icon>
                      </button>
                      {{ node.name }}
                      <div (click)="handleButtonClick($event)">
                        <button
                          mat-icon-button
                          [matMenuTriggerFor]="clanMenu.menu"
                          aria-label="Example icon-button with a menu"
                          (click)="onNodeClick(node)"
                          [disabled]="!islastSelectedClanFullAccessible_"
                        >
                          <mat-icon class="mat-icon-rtl-mirror">add_circle_outline</mat-icon>
                        </button>
                      </div>
                    </div>
                    <!-- There is inline padding applied to this div using styles.
          This padding value depends on the mat-icon-button width.  -->
                    <div
                      [class.example-tree-invisible]="
                        !treeControl.isExpanded(node)
                      "
                      role="group"
                    >
                      <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                  </mat-nested-tree-node>
                </mat-tree>
              </div>
              <!-- <div class="example-large-box mat-elevation-z4">
  </div> -->
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>

    <app-clan-menu
      #clanMenu
      (dialogClosed)="onRowSelectionChange($event)"
    ></app-clan-menu>
    <!-- Replaces the mat-menu -->
  `,
  styleUrl: './available-clans.component.css',
})
export class AvailableClansComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  route_: ActivatedRoute = inject(ActivatedRoute);
  private http: HttpClient;

  subClans_: SubClan[] = subClans;
  direction_: 'ltr' | 'rtl' = 'rtl'; // Default direction
  constructor(
    private accountService_: AccountService,
    private personService: PersonService,
    http: HttpClient,
    public CreatePersonDialog: MatDialog,
    private dataSharingService_: DataSharingService,
    private router: Router,
    private clanService_: ClanService,
    private snackBar: MatSnackBar,
    private elRef: ElementRef,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {
    this.http = http;
    this.accordion = new MatAccordion(); // Initialize the 'accordion' property
    this.userAccount_ = new DefaultUserAccount();
    this.targetPerson_ = new DefaultPersonTable();
    this.dataSourceTree.data = TREE_DATA;
    // this.lastSelectedRow_ = subClans[0];
  }
  ngOnInit() {
    this.authenticate();
    this.userAccount_;
    this.setDirection(this.translate.currentLang);

    // Update direction on language change
    this.translate.onLangChange.subscribe((event) => {
      this.setDirection(event.lang);
    });
  }

  private setDirection(language: string): void {
    this.direction_ = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', this.direction_);
    this.cdr.detectChanges(); // Force Angular to update the UI
  }
  ngOnDestroy() {}
  clansDataSource = new MatTableDataSource(this.subClans_);
  selection = new SelectionModel<SubClan>(true, []);
  displayedColumns: string[] = [
    'select',
    'owner_name',
    'name',
    'start_of_family_name',
  ];

  treeControl = new NestedTreeControl<TreeNode>((node) => node.children);
  dataSourceTree = new MatTreeNestedDataSource<TreeNode>();
  hasChild = (_: number, node: TreeNode) =>
    !!node.children && node.children.length > 0;

  protected userAccount_: UserAccount;
  private targetPerson_: PersonInterface;
  protected authenticate_uri: string = 'authenticate';
  protected authenticationOk_ = false;
  protected islastSelectedClanReadable_ = false;
  protected islastSelectedClanFullAccessible_ = false;
  showRating = false;
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.clansDataSource.filter = filterValue.trim().toLowerCase();
  }

  authenticate() {
    const loginKey = localStorage.getItem('loginKey');
    if (!loginKey) {
      this.router.navigate(['login']);
      return; // Stop further execution if no token
    }
    const token = localStorage.getItem(loginKey);
    if (!token) {
      this.router.navigate(['login']);
      return; // Stop further execution if no token
    }

    this.userAccount_.authentication = token;
    this.accountService_
      .run(this.userAccount_, this.authenticate_uri)
      .subscribe({
        next: (response) => {
          // Check the response status within the `next` block
          if (response.status === '401') {
            // If it's a 401 status, manually handle it as an error
            console.error('Authentication failed: Unauthorized access.');
            localStorage.removeItem('loginKey');
            this.router.navigate(['login']);
          } else {
            // Successful authentication logic
            console.log('authentication successful', response.authentication);
            this.userAccount_ = response;
            this.dataSharingService_.setActiveUserAccount(this.userAccount_);

            if (this.userAccount_.id != '') {
              this.fetchPermittedClans();
            }
          }
        },
        error: (error) => {
          // Handle any server errors (401, 500, etc.)
          if (error.status === 401) {
            // Authentication failed: Redirect to login
            console.error('Authentication failed: ', error.message);
            localStorage.removeItem(this.userAccount_.email); // Optionally clear the invalid token
            this.router.navigate(['login']); // Redirect to login page
          } else {
            // Handle other types of errors
            console.error('An unexpected error occurred: ', error);
          }
        },
      });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row: SubClan): string {
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.family_table_name + 1}`;
  }

  onRowSelectionChange(row: SubClan): void {
    console.log('onRowSelectionChange');

    // Select the clicked row
    this.selection.select(row);
    this.dataSharingService_.setLastSelectedClan(row);
    this.islastSelectedClanFullAccessible_ = row.full_access;
    this.islastSelectedClanReadable_ = row.read;
    // Deselect other rows
    this.clansDataSource.data.forEach((item) => {
      if (item !== row) {
        this.selection.deselect(item);
      }
    });

    const baseUrl = environment.baseUrl;
    const url = `${baseUrl}/displayTree?id=${row.family_table_id}`;

    // Make an HTTP request to fetch JSON data from the backend
    this.http.get(url).subscribe({
      next: (response: any) => {
        // Handle the response from the backend (optional)
        console.log(response); // Example: Log the response data
        this.dataSourceTree.data = response;
        // this.dataSharingService_.updateTreeData(response);
      },
      error: (error) => {
        console.error('Error fetching tree data:', error); // Handle errors
      },
    });
  }

  selectTab(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    console.log(`Tab ${selectedTabIndex} (${selectedTabLabel}) selected`);
    // Your logic for handling the selected tab goes here
    if (selectedTabIndex == 0) {
      this.fetchPermittedClans();
    }
  }

  onNodeClick(node: TreeNode): void {
    if (
      this.islastSelectedClanReadable_ &&
      !this.islastSelectedClanFullAccessible_
    ) {
      // Show a snackbar message if the user only has read permissions
      this.snackBar.open(
        'You have only read permission on this tree',
        'Close',
        {
          duration: 3000, // Duration in milliseconds
        },
      );
    } else {
      this.targetPerson_.id = node.id;
      this.dataSharingService_.setTargetPerson(this.targetPerson_);
      console.log('Selected Node ID:', this.targetPerson_.id);
    }
  }

  handleButtonClick(event: MouseEvent): void {
    if (!this.islastSelectedClanFullAccessible_) {
      // Prevent click from propagating to the button if it's disabled
      event.stopPropagation();

      // Show a snackbar message informing the user about read-only access
      // Configure the snackbar to appear at the top
      this.snackBar.open(
        'You have only read permission on this tree',
        'Close',
        {
          duration: 3000, // Duration in milliseconds
          horizontalPosition: 'center', // You can choose 'start', 'center', 'end', 'left', or 'right'
          verticalPosition: 'top', // You can choose 'top' or 'bottom'
        },
      );
    }
    // If the button is enabled, it will work as usual without further action here
  }

  updateDataSource(newData: SubClan[]): void {
    this.clansDataSource.data = newData;
  }

  isLoading = true; // Add a flag for loading state

  fetchPermittedClans() {
    this.isLoading = true;
    this.clanService_
      .fetchPermittedClans(this.userAccount_.id)
      .pipe(retry(1))
      .subscribe({
        next: (clans: SubClan[]) => {
          this.isLoading = false;
          if (clans && clans.length > 0) {
            this.updateDataSource(clans);
          } else {
            console.error('No clans found.');
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error fetching clans:', error);
        },
      });
  }

  onPersonalDataSaved(): void {}

  toggleRating() {
    this.showRating = !this.showRating;
    console.log('Toggled showRating:', this.showRating);
  }

  onDropdownClose() {
    this.showRating = false;
    console.log('Dropdown closed');
  }
}
